"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.goToVerifyEmailPage = exports.goToSocialCreateAccountPage = exports.goToSocialAcessCodePage = exports.goToPhoneNumberLoginPage = exports.goToPhoneConfirmationPage = exports.goToOwnershipVerificationPage = exports.goToLoginPageWithQueryParams = exports.goToLoginPage = exports.goToEmailConfirmationPage = exports.goToCredencialAssociatedPage = exports.goToCreateAccountPage = exports.goToActivateAccountPage = exports.goToAccountMatchPage = exports.goToAccessCodePage = exports.customGoBack = void 0;
var _reactRouterRedux = require("react-router-redux");
var _actions = require("./actions");
var _constants = require("./constants");
var customGoBack = function customGoBack(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.goBack)());
  };
};
exports.customGoBack = customGoBack;
var goToLoginPage = function goToLoginPage(dispatch) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)("".concat(_constants.loginPaths.root).concat(query)));
  };
};
exports.goToLoginPage = goToLoginPage;
var goToLoginPageWithQueryParams = function goToLoginPageWithQueryParams(dispatch) {
  return function () {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.root + params));
  };
};
exports.goToLoginPageWithQueryParams = goToLoginPageWithQueryParams;
var goToPhoneNumberLoginPage = function goToPhoneNumberLoginPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.phoneNumberLogin));
  };
};
exports.goToPhoneNumberLoginPage = goToPhoneNumberLoginPage;
var goToAccessCodePage = function goToAccessCodePage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.accessCode));
  };
};
exports.goToAccessCodePage = goToAccessCodePage;
var goToActivateAccountPage = function goToActivateAccountPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.activateAccount));
  };
};
exports.goToActivateAccountPage = goToActivateAccountPage;
var goToCreateAccountPage = function goToCreateAccountPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.createAccount));
  };
};
exports.goToCreateAccountPage = goToCreateAccountPage;
var goToVerifyEmailPage = function goToVerifyEmailPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.verifyEmail));
  };
};
exports.goToVerifyEmailPage = goToVerifyEmailPage;
var goToPhoneConfirmationPage = function goToPhoneConfirmationPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialPhoneConfirmation));
  };
};
exports.goToPhoneConfirmationPage = goToPhoneConfirmationPage;
var goToOwnershipVerificationPage = function goToOwnershipVerificationPage(dispatch) {
  return function (data) {
    if (data) {
      dispatch((0, _actions.loginUserSocialCredentialMatched)(data));
    }
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialOwnershipVerification));
  };
};
exports.goToOwnershipVerificationPage = goToOwnershipVerificationPage;
var goToAccountMatchPage = function goToAccountMatchPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialAccountMatch));
  };
};
exports.goToAccountMatchPage = goToAccountMatchPage;
var goToEmailConfirmationPage = function goToEmailConfirmationPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialEmailConfirmation));
  };
};
exports.goToEmailConfirmationPage = goToEmailConfirmationPage;
var goToCredencialAssociatedPage = function goToCredencialAssociatedPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialCredentialAssociated));
  };
};
exports.goToCredencialAssociatedPage = goToCredencialAssociatedPage;
var goToSocialCreateAccountPage = function goToSocialCreateAccountPage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialCreateAccout));
  };
};
exports.goToSocialCreateAccountPage = goToSocialCreateAccountPage;
var goToSocialAcessCodePage = function goToSocialAcessCodePage(dispatch) {
  return function () {
    dispatch((0, _actions.clearResponse)());
    dispatch((0, _reactRouterRedux.push)(_constants.loginPaths.socialAccessCode));
  };
};
exports.goToSocialAcessCodePage = goToSocialAcessCodePage;